import React from "react";
import Logo from "../../assets/img/logo.webp";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import "../../assets/css/footer.css";

const Footer = () => {
  return (
    <footer className="footer text-white py-4">
      <div className="container ">
        <div className="row align-items-end">
          <div className="col-12 col-md-3 d-flex flex-row justify-content-center gap-2 gap-md-0 flex-md-column gap-0 m-0 text-center text-md-left mb-md-0">
            <a className="text-dark fs-14  p-0 m-0  1h-1" href="/terms-of-use">
              Terms of Use
            </a>
            <a className="text-dark fs-14 m-0 1h-1" href="/privacy-policy">
              Privacy Policy
            </a>
            <a
              className="text-dark fs-14  p-0 m-0  1h-1"
              href="/cookies-policy"
            >
              Cookies Policy
            </a>
          </div>

          <div className="col-12 col-md-6 text-center ">
            <img src={Logo} alt="Logo" className="footer-logo img-fluid" />
            <p className="text-dark fs-14 p-0 m-0 1h-1">
              Copyright {new Date().getFullYear()}. All rights reserved
            </p>
            <p className="p-0 m-0 fs-14 text-dark 1h-1">
              designed and maintained by{" "}
              <a
                href="https://www.dimensiondigital.co.uk"
                target="_blank"
                className="text-dark"
              >
                Dimension Digital{" "}
              </a>
            </p>
          </div>

          <div className="col-12 col-md-3 d-flex flex-row flex-md-column align-items-center justify-content-center align-items-md-end">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon "
            >
              <FaFacebook size={20} color="#000000" />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaInstagram size={20} color="#000000" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
